import React from 'react';
import { baseurl } from '../../general';
import ModelInfo from './ModelInfo';
import Views from './Views';
import ModelLinks from './ModelLinks';
import instagramLogo from '../../static/instagram.png';
import './Model.css';

const DownloadPortfolio = ({ gallery, name }) => (
  <div className="modelpage_header_download_portfolio">
    <a href={`${baseurl}pdf_type/${name}/${gallery}`}>
      {`download ${gallery} as pdf file`}
    </a>
    <br />
  </div>
);
// <a href={`${baseurl}pdf_all/${name}/`}>
// download whole catalogue as pdf file
// </a>

export default ({ match, sizes, names, galleries, setViewSize, viewSize }) => {
  const info = match.params.name !== undefined && (
    <>
      <ModelInfo sizes={sizes} names={names} galleries={galleries} match={match} />
      <DownloadPortfolio gallery={match.params.gallery} name={match.params.name} />
      {names.instagram && <a className="instagram" target="_blank" rel="noreferrer" href={names.instagram}><img className="instagram" src={instagramLogo} alt="instagram" /></a>}
    </>
  );
  return (
    <div className={match.params.name ? "modelpage_header" : "modelspage_header"}>
      <ModelLinks match={match} galleries={galleries} />
      <Views setViewSize={setViewSize} viewSize={viewSize} />
      {info}
    </div>
  );
};
